import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserActivityLogService } from '../../../services/user-activity-log.service';
import { switchMap, withLatestFrom, map, catchError, combineLatest, filter } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { UserActivityLogActionTypes, UserActivityLogActions } from '../actions/user-activity-log.actions';
import { UserActivityLog, UserActivityEntities } from '../user-activity-log.model';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';


@Injectable()
export class UserActivityLogEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private userActivityLogService = inject(UserActivityLogService);

  constructor() {}

  GetUserActivityLogs$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.GetUserActivityLogs),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const today = new Date();
      // const enddate = today.getFullYear() + '/' + (today.getMonth() + 1);
      // Start_date往前取 2 個月
      const baseDate = new Date(action.payload.start_date * 1000);
      // --- 計算 startdate (UTC) --- 目標：上 2 個月的 1號 00:00:00 UTC
      const startdate = Date.UTC(baseDate.getUTCFullYear(),baseDate.getUTCMonth() - 2,1, 0, 0, 0) / 1000;
      // date.setMonth(date.getMonth() - 1);
      // date.setDate(1);
      // date.setHours(0, 0, 0, 0);
      // const startdate = Math.floor(date.getTime() / 1000);
      const enddate = new Date().getTime() / 1000;
      const param = {
        otp: user.otp,
        type: action.payload.type,
        region: action.payload.region,
        // start_date: '2019/12',
        start_date: startdate,
        end_date: enddate,
      };
      return this.userActivityLogService.ReadUserActivityLog(param).pipe(
        map((res: any) => {
          const result: UserActivityEntities = {
            UserActivityLogNode: [],
            start_date: action.payload.start_date,
            end_date: action.payload.end_date,
            is_AllTime: action.payload.is_AllTime
          };
          if (res.result) {
            result.UserActivityLogNode = res.msg.body;
            return new featureActions.LoadUserActivityLogs(result);
          } else {
            return new featureActions.GetUserActivityLogsFail(result);
          }
        })
      );
    })
  ));
  ReadProIncomeList$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.GetProIncomeList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const payload = { ...action.payload, otp: user.otp };
      return this.userActivityLogService.ReadProIncomeList(payload).pipe(
        map((res: any) => {
          if (res.result) {
            const result = {
              proIncomeData: res.msg.body,
              Year: action.payload.Year
            };
            return new featureActions.LoadProIncomeList(result);
          } else {
            return new featureActions.GetProIncomeListFail(res.msg.body);
          }
        })
      );
    })
  ));
  UpdateProIncome$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.UpdateProIncome),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const payload = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateProIncome
      };
      return this.userActivityLogService.UpdateProIncome(payload).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.UpdateProIncomeSuccess(res.msg.body),
              new featureActions.UpdateInfoSuccessAction(updateRes)];
          } else {
            return [
              new featureActions.UpdateProIncomeFail(res.msg.body),
              new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        catchError((error) => {
          return [
            new featureActions.UpdateProIncomeFail(),
            new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  GetReportDiscountList$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.GetReportDiscountList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.userActivityLogService.ReadReportDiscountList(user.otp).pipe(
        map((res: any) => {
          if (res.result) {
            return new featureActions.LoadReportDiscountList(res.msg.body);
          } else {
            return new featureActions.GetReportDiscountListFail(res.msg.body);
          }
        })
      );
    })
  ));
  AddReportDiscount$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.AddReportDiscount),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const payload = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddReportDiscount
      };
      return this.userActivityLogService.AddReportDiscount(payload).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.AddReportDiscountSuccess(res.msg.body),
              new featureActions.UpdateInfoSuccessAction(updateRes)];
          } else {
            return [
              new featureActions.AddReportDiscountFail(res.msg.body),
              new featureActions.UpdateInfoFailAction({ ...updateRes, msg: res.msg })];
          }
        }),
        catchError((error) => {
          return [
            new featureActions.AddReportDiscountFail(),
            new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateReportDiscount$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.UpdateReportDiscount),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const payload = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateReportDiscount
      };
      return this.userActivityLogService.UpdateReportDiscount(payload).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.UpdateReportDiscountSuccess(res.msg.body),
              new featureActions.UpdateInfoSuccessAction(updateRes)];
          } else {
            return [
              new featureActions.UpdateReportDiscountFail(res.msg.body),
              new featureActions.UpdateInfoFailAction({ ...updateRes, msg: res.msg })];
          }
        }),
        catchError((error) => {
          return [
            new featureActions.UpdateReportDiscountFail(),
            new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  DeleteReportDiscount$ = createEffect(() => this.actions$.pipe(
    ofType(UserActivityLogActionTypes.DeleteReportDiscount),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const payload = { ...action.payload, otp: user.otp };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteReportDiscount
      };
      return this.userActivityLogService.DeleteReportDiscount(payload).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
              new featureActions.DeleteReportDiscountSuccess(res.msg.body),
              new featureActions.UpdateInfoSuccessAction(updateRes)];
          } else {
            return [
              new featureActions.DeleteReportDiscountFail(res.msg.body),
              new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        catchError((error) => {
          return [
            new featureActions.DeleteReportDiscountFail(),
            new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
